import { render, staticRenderFns } from "./PersistGlobalView.vue?vue&type=template&id=0a18ef38"
import script from "./PersistGlobalView.vue?vue&type=script&lang=ts"
export * from "./PersistGlobalView.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports